import { useCallback, useEffect, useRef } from 'react';

type Props = {
  interval: number;
  events?: string[];
  onChange: () => void;
};

function useIdle(props: Props) {
  const { events = ['mousemove', 'mousedown', 'keydown', 'scroll'], interval, onChange } = props;
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleEvent = useCallback(() => {
    if (timeout.current) {
      return;
    }

    timeout.current = setTimeout(() => {
      onChange();
      timeout.current && clearTimeout(timeout.current);
      timeout.current = null;
    }, interval);
  }, [interval, onChange]);

  useEffect(() => {
    events.forEach(event => {
      window.addEventListener(event, handleEvent);
    });

    return () => {
      timeout.current && clearTimeout(timeout.current);
      timeout.current = null;
      events.forEach(event => {
        window.removeEventListener(event, handleEvent);
      });
    };
  }, [events, handleEvent, onChange]);
}

export default useIdle;
